<markant-platform-modal-bridge>
  <markant-dialog
    class="service-responsibility-dialog"
    [headTitle]="
      'cartridge.management.serviceResponsibility.dialog.title' | transloco
    "
    [open]="true"
    (close)="onClose()"
  >
    <div class="content">
      <p>
        {{
          'cartridge.management.serviceResponsibility.dialog.message'
            | transloco
        }}<br /><br />
        <span
          >{{
            'cartridge.management.serviceResponsibility.dialog.note'
              | transloco
          }}:</span
        >
        {{
          'cartridge.management.serviceResponsibility.dialog.noteMessage'
            | transloco
        }}
      </p>

      <div class="user-selection">
        <markant-input
          class="user-selection-field"
          data-cy="input-search-service-manager"
          outlined="true"
          [label]="
            'cartridge.management.serviceResponsibility.dialog.currentManagerLabel'
              | transloco
          "
          [value]="serviceManager"
          [readonly]="true"
        >
        </markant-input>

        <markant-combi-select
          class="user-selection-field"
          label="{{
            'cartridge.management.serviceResponsibility.dialog.newManagerLabel'
              | transloco
          }}"
          outlined="true"
          [clearable]="!!selectedServiceManager"
          [value]="selectedServiceManager?.name"
          [disabled]="isLoading"
          (valueChange)="onValueChanged($any($event).detail)"
          (optionSelectedChange)="onServiceManagerSelected($any($event).detail)"
          (clear)="onClearServiceManager()"
        >
          <markant-combi-select-option
            *ngFor="let user of filteredServiceManagers"
            [value]="user.id"
          >
            {{ user.name }}
          </markant-combi-select-option>
        </markant-combi-select>
      </div>
    </div>

    <div slot="footer" class="footer">
      <markant-button colorScheme="primary" variant="clear" (click)="onClose()">
        {{ 'common.cancel' | transloco }}
      </markant-button>

      <markant-button
        colorScheme="primary"
        [loading]="isLoading"
        [disabled]="!selectedServiceManager"
        (click)="onSave()"
      >
        {{ 'common.save' | transloco }}
      </markant-button>
    </div>
  </markant-dialog>
</markant-platform-modal-bridge>
